import { t } from "i18next";
import { StatusFile } from "@/common/enums/enums";
import { useVisitDetail } from "@/lib/visit-queries";
import type { FileData } from "@/services/files";

export const useSummarizationSocket = (
  file: Pick<FileData, "public_id" | "status">,
): {
  result: string | null;
  isLoading: boolean;
  error: string | null;
} => {
  const visit = useVisitDetail(file.public_id);
  const failed = visit.file?.status === StatusFile.ERROR;
  return {
    result: visit.file?.result ?? null,
    isLoading:
      !visit.error &&
      (visit.loading ||
        visit.file?.status === StatusFile.PROCESSING ||
        visit.file?.status === StatusFile.GENERATING),
    error: !visit.scope
      ? t("visit.summarization.signIn")
      : visit.error
        ? t("visit.summarization.loadFailed")
        : failed
          ? t("visit.summarization.failed")
          : null,
  };
};
